import path from "path"

export const enum BackendSystems {
  CXCORE = "cxcore",
  DGK = "dgk",
  BACKEND = "backend",
  INTROSPECT = "introspect"
}
export const endpoints = {
  prepare: {
    aspect: {
      get: {
        path: `configuration/models/aspects`,
        system: BackendSystems.CXCORE
      }
    }
  },
  provider: {
    usecases: {
      get: { path: `configuration/usecases`, system: BackendSystems.CXCORE }
    },
    csvUpload: {
      path: `jobs/provisions/csv`,
      system: BackendSystems.CXCORE
    },
    restApiUpload: {
      path: `provider/publish-offer`,
      system: BackendSystems.DGK
    },
    jsonUpload: {
      path: "jobs/provisions",
      system: BackendSystems.CXCORE
    },
    assets: {
      fetchAll: {
        path: "assets/request",
        system: BackendSystems.DGK
      },
      fetchById: {
        path: "assets/list",
        system: BackendSystems.DGK
      },
      edit: {
        path: "assets",
        system: BackendSystems.DGK
      },
      dctType: {
        path: "assets/dctType",
        system: BackendSystems.DGK
      },
      unpublish: {
        path: "provider/unpublish-offer",
        system: BackendSystems.DGK
      }
    }
  },
  connector: {
    get: { path: `connector-info/list`, system: BackendSystems.DGK }
  },
  connections: {
    get: {
      path: `external-connections-manager/connection/organisation`,
      system: BackendSystems.DGK
    }
  },
  policy: {
    get: {
      path: `policydefinitions/request`,
      system: BackendSystems.DGK
    }
  },
  catalog: {
    query: {
      path: `catalog/query`,
      system: BackendSystems.DGK
    }
  },
  contractDefinitions: {
    get: {
      path: "contractDefinitions/request",
      system: BackendSystems.DGK
    }
  },
  asset: {
    uploadHistory: {
      path: `provider/upload-history`,
      system: BackendSystems.DGK
    }
  },
  // TODO: the "digitalTwin"-urls have to be implemented in digitalTwinService
  digitalTwin: {
    provider: {
      get: {
        path: "provisions/documents/shells",
        system: BackendSystems.CXCORE
      }
    },
    consumer: {
      get: {
        path: "consumptions/documents/shells",
        system: BackendSystems.CXCORE
      }
    }
  },
  jobs: {
    path: "jobs",
    system: BackendSystems.CXCORE
  },
  consumption: {
    exportToCsv: {
      path: `/consumptions/aspects`,
      system: BackendSystems.CXCORE
    },
    downloadHistory: {
      path: "consumer/download-history",
      system: BackendSystems.DGK
    },
    downloadOffer: {
      path: "consumer/re-download",
      system: BackendSystems.DGK
    },
    transferInitiate: {
      path: "transfer/initiate-process",
      system: BackendSystems.DGK
    },
    transferDestination: {
      path: "transfer/initiate-process-for-data-destination",
      system: BackendSystems.DGK
    }
  },
  applications: {
    pcf: {
      request: {
        path: "provisions/pcfs/requests",
        system: BackendSystems.CXCORE
      },
      requests: {
        path: "pcfs/requests",
        system: BackendSystems.CXCORE
      },
      responses: {
        path: "pcfs/responses",
        system: BackendSystems.CXCORE
      }
    },
    pcfV9: {
      request: {
        path: "provisions/v2/pcfs/requests",
        system: BackendSystems.CXCORE
      },
      requests: {
        path: "v2/pcfs/requests",
        system: BackendSystems.CXCORE
      },
      responses: {
        path: "v2/pcfs/responses",
        system: BackendSystems.CXCORE
      }
    },
    certificate: {
      push: {
        path: "jobs/provisions/messages",
        system: BackendSystems.CXCORE
      },
      update: {
        path: "provisions/aspects",
        system: BackendSystems.CXCORE
      }
    },
    blockingNotifications: {
      statistics: {
        path: "message/notification/statistics/blocknotifications",
        system: BackendSystems.CXCORE
      }
    },
    cyberSecurityKPIs: {
      get: {
        path: "provisions/messages",
        system: BackendSystems.CXCORE
      }
    },
    electronicControlUnit: {
      statistics: {
        path: "message/notification/statistics/ecu",
        system: BackendSystems.CXCORE
      }
    }
  },
  introspection: {
    get: { path: `info?profile=profile-ui`, system: BackendSystems.INTROSPECT }
  }
}
